export default __webpack_public_path__ + "static/media/james.d45b7251.jpg";